const en = {
    Common: {
        CODE: "Code",
        NEXT: "Next",
        SAVE: "Save",
        APPLY: "Apply",
        ACTION: "Action",
        GO_BACK: "Back",
        DETAIL: "Detail",
        DISPLAY: "Rows per page",
        APPROVE: "Approve",
        ACTIVE: "Active",
        ACTIVED: "Actived",
        IN_ACTIVE: "Inactive",
        EDIT: "Edit",
        CLOSE: "Close",
        DELETE: "Delete",
        STATUS: "Status",
        ADD_NEW: "New",
        VIEW_ALL: "View all",
        VIEW_DETAIL: "View detail",
        LOAD_MORE: "Load more",
        CREATE_NEW: "Create new",
        SEND: "Send",
        REMOVE_FROM_SERVICE: "Remove from service",
        DRAFT: "Draft",
        ACCEPT: "Accept",
        CANCEL: "Cancel",
        LOCKED: "Locked",
        DELETED: "Deleted",
        CHANGE_STATUS: "Change status",
        REJECT: "Reject",
        REJECTED: "Rejected",
        PENDING: "Pending",
        EXPIRED: "Expired",
        ACCEPTED: "Accepted",
        INVITING: "Inviting",
        PENDING_INVITATION: "Pending invitation",
        RESET: "Reset",
        FILTER: "Filter",
        FILTER_LIST: "Filter list",
        SEARCH: "Search",
        SELECT: "Select",
        CANCEL_SELECT: "Cancel select",
        SELECTED_RECORD: "Selected {0} records",
        LABEL_DISPLAY_ROWS: "{0} - {1} of {2}",
        PLEASE_COMPLETE_ALL_INFORMATION: "Please check the requested information again",
        CANCEL_ACTION_MESSAGE: "Edit information has not been saved. Are you sure you want to leave the current screen?",
        NOT_PERMISSION: "Sorry, you do not have permission to access",
        NO_DATA: "No data",
        WARNING_OWNER: "You do not have permission to update this role",
        SEQUENCE: "Sequence",
        REQUIRED: "Data field is required",
        ERROR: "An error occurred during processing, please try again later. Sorry for causing inconvenience.",
        EMAIL_ADDRESS: "Wrong email format",
        WRONG_PHONE_NUMBER: "Wrong phone number format",
        INVALID_TIME: "Invalid time",
        MALE: "Male",
        FEMALE: "Female",
        OTHER: "Other",
        UPDATE: "Update",
        ADD_OR_REMOVE: "Edit",
        ADD_RESOURCES: "Add resources",
        ALL: "All",
        INVALID_EMAIL: "Invalid email",
        DEFAULT: "Default",
        MULTI_LANGUAGE: "Multi language",
        VI: "Vietnamese",
        EN: "English",
        CONTINUE: "Continute",
        PAUSE: "Pause",
        YES: "Yes",
        NO: "No",
        NOTIFICATION: "Notification",
        DROP_FILES_HERE: "Drop file(s) here",
        UPLOAD_FILE_FROM_LOCAL: "Upload from computer",
        UPLOAD_FILE_FROM_URL: "Enter file's url",
        CHANGE: "Change",
        ENTER_FILE_URL: "Enter file URL",
        TOTAL: "Total",
        UPLOAD_FILE_ERROR: "Failed to uploading file",
        INVALID_FILE: "File is invalid",
        PREVIEW: "Preview",
        IMAGE: "Image",
        VIDEO: "Video",
        DOCUMENT: "Document",
        DOWNLOAD: "Download",
        FILE_SIZE_MUST_SMALLER_THAN: "File size must be smaller than {0}",
        VIDEO_MUST_BE_MP4_FORMAT: "Video must be MP4 format",
        CANCEL_UPLOAD_VIDEO: "Are you sure to cancel uploading this video?",
        UPLOAD_VIDEO_FAILED: "Video upload failed",
        CANCEL_UPLOAD_IMAGE: "Are you sure to cancel uploading this image?",
        UPLOAD_IMAGE_FAILED: "Image upload failed",
        UPLOAD_VIDEO: "Upload video",
        REPLACE: "Replace",
        CHOOSE_IMAGE: "Choose image",
        COMPLETE: "Complete",
        PLEASE_SELECT_AN_ORGANIZATION: "Please select an organization",
        SKIP: "Skip",
        UNDER_MANAGEMENT: "Under management",
        EMAIL_ALREADY_EXISTS: "Email already exists",
        LOADING_PDF: "Loading PDF",
        LOAD_PDF_ERROR: "Error when loading PDF",
        PAGE: "Page",
        ZOOM_IN: "Zoom in",
        ZOOM_OUT: "Zoom out",
        REMOVE: "Remove",
        UPLOAD: "Upload",
        DRAG_AND_DROP_FILES_HERE_OR_CLICK: "Drag and drop files here or click",
        HTML_EDITOR_CONTENT_ERROR: "Content size too large. You can use image uploader on toolbar to reduce content size",

        //
        LOGOUT: "Logout",
        DO_NOT_CHOOSE: "Don't choose",
        ACCOUNT_INFO: "Profile",
        STAFF: "Staff",
        GROUP: "Group",
        ORGANIZATION: "Organization",
        ADVANCE: "Advance",
        NORMAL: "Normal",
        SELECTED: "Selected",
        COPY: "Copy",
    },

    Languages: {
        VIETNAM: "Viet Nam",
        VI: "Vietnamese",
        EN: "English",
    },

    MESSAGE: {
        CONFIRM_DELETE: "Do you want to delete?",
        DELETE_SUCCESS: "Delete success",
        CONFIRM_CHANGE_STATUS: "Do you want to change status?",
        CREATE_SUCCESS: "Create success",
        UPDATE_SUCCESS: "Update success",
        UPDATE_STATUS_SUCCESS: "Update status success",
    },

    Role: {
        BASIC_INFO: "Basic information Role",
        SEARCH_TEXT: "Search by name",
        ENTER_SEARCH_TEXT: "Enter name",
        CODE: "Code",
        NAME_ROLE: "Name",
        ENTER_NAME_ROLE: "Enter name",
        DESCRIPTION: "Description",
        ENTER_DESCRIPTION: "Enter description",
        SHOW: "Show",
        SERVICE_NAME: "Service",
        SELECT_SERVICE: "Select service",
        RESOURCE: "Resource",
        ROLE: "Role",
        READ: "Read",
        VIEW_DETAIL: "View detail",
        READ_LIST: "View list",
        CREATE: "Create",
        BULK_CREATE: "Bulk create",
        UPDATE: "Update",
        BULK_UPDATE: "Bulk update",
        DELETE: "Delete",
        BULK_DELETE: "Bulk elete",
        IMPORT: "Import",
        EXPORT: "Export",
        NONE: "None",
        OWNER: "Owner",
        MANAGER: "Management",
        TYPE: "Type",
        SELECT_TYPE: "Select type",
        NORMAL: "Normal",
        DEFAULT_ROLE: "Default",
        SERVICE_ROLE: "Service Role",
        MEMBER: "Member",
        OWNER_ROLE: "Organization Owner",
        ORGANIZATION_ADMIN: "Organization Admin",
        GROUP_ADMIN_ROLE: "Group admin",
        SERVICE_ADMIN: "Service Admin",
        CONFIRM_DELETE: "Do you want to delete?",
        DELETE_SUCCESS: "Delete success",
        CONFIRM_CHANGE_STATUS: "Do you want to change status?",
        CREATE_SUCCESS: "Create success",
        UPDATE_SUCCESS: "Update success",
        UPDATE_STATUS_SUCCESS: "Update status success",
    },

    Organization: {
        MANAGEMENT_ORGANIZATIONS: "{0} management",
        ADD_ORGANIZATIONS: "Add {0}",
        ADD_STAFF: "Add {0}",
        ADD_GROUP: "Add {0}",
        BASIC_INFO: "Basic information {0}",
        SEARCH_TEXT: "Search by name {0}",
        ENTER_SEARCH_TEXT: "Enter name {0}",
        CODE: "{0} code",
        NAME: "{0} name",
        ENTER_NAME: "Enter {0} name",
        PHONE_NUMBER: "Phone number",
        ENTER_PHONE_NUMBER: "Enter phone number",
        EMAIL: "Email",
        ENTER_EMAIL: "Enter Email",
        FAX_NUMBER: "Fax number",
        ENTER_FAX_NUMBER: "Enter fax number",
        TAX_NUMBER: "Tax number",
        ENTER_TAX_NUMBER: "Enter tax number",
        WEBSITE: "Website",
        ENTER_WEBSITE: "Enter website",
        DESCRIPTION: "Description",
        ENTER_DESCRIPTION: "Enter description",
        IMAGE_PHOTO: "Logo {0}",
        OWNER: "Owner {0}",
        ADD_OWNER: "Designate the {0} owner",
        EMAIL_OWNER: "Owner email",
        ENTER_EMAIL_OWNER: "Enter email to assign owner {0}",
        TOTAL_STAFF: "Total {0}",
        TOTAL_GROUP: "Total {0}",
        SELECT_STATUS: "Select status",
        DELETE_SUCCESS: "Deleted {0} successfully!",
        CREATE_SUCCESS: "Created new {0} successful!",
        UPDATE_SUCCESS: "Updated the {0} information successfully!",
        CONFIRM_ACTIVE_STATUS: "Are you sure you want to go into active state?",
        CONFIRM_IN_ACTIVE_STATUS: "Are you sure you want to go into inactive state?",
        IN_ACTIVE_STATUS_SUCCESS: "Update status to inactive status successfully",
        ACTIVE_STATUS_SUCCESS: "Update status to active status successfully!",
        CONFIRM_REMOVE_SERVICE: "Do you really want to delete this {0}?",
        CONFIRM_CHANGE_OWNER: "You definitely want to change to a new {0} owner?",
    },

    Group: {
        BASIC_INFO: "Basic information {0}",
        SEARCH_TEXT: "Search by name",
        SEARCH_PLACEHOLDER: "Enter name {0}",

        CODE_GROUP: "{0} code",
        GROUP_PARENT: "Parent {0}",
        SELECT_GROUP_PARENT: "Select parent {0}",
        NAME_GROUP: "{0} name",
        ENTER_NAME_GROUP: "Enter {0} name",
        CHILD_NUMBER: "{0} child",
        CONFIRM_DELETE_WHEN_HAVE_CHILD_GROUP:
            "If you delete this {0}, the {1} child will be simultaneously deleted. Are you sure you want to delete?",
        CONFIRM_DELETE: "Do you really want to delete this {0}?",
        CREATE_SUCCESS: "Created a new {0} successfully!",
        UPDATE_SUCCESS: "Updated {0} information successfully!",
        DELETE_SUCCESS: "Deleted {0} successfully!",

        TITLE_CREATE: "Add new {0}",
        TITLE_DETAIL: "Detail {0}",
        TITLE_UPDATE: "Update {0}",

        CONFIRM_USER_BY_GROUP_DELETE: "Bạn chắc chắn muốn xóa {0} này khỏi {1} này?",
        DELETE_USER_BY_GROUP_SUCCESS: "Đã xóa {0} khỏi {1} thành công!",
        CREATE_USER_BY_GROUP_SUCCESS: "Đã thêm {0} vào {1} thành công!",
    },

    Staff: {
        TITLE_LIST_VIEW: "Members",
        TITLE_CREATE_VIEW: "Add New {0}",
        TITLE_UPDATE_VIEW: "Update {0}",
        TITLE_DETAIL_VIEW: "Detail {0}",
        BASIC_INFO: "Basic information {0}",
        SEARCH_TEXT: "Search by name {0}",
        ENTER_SEARCH_TEXT: "Enter name {0}",

        CODE: "{0} code",
        FIRST_NAME: "First name",
        LAST_NAME: "Last name",
        ENTER_FIRST_NAME: "Enter first name",
        ENTER_LAST_NAME: "Enter last name",
        FULL_NAME: "Full name",
        GENDER_MALE: "Male",
        GENDER_FEMALE: "Female",
        ENTER_NAME: "Enter full name",
        PHONE_NUMBER: "Phone number",
        ENTER_PHONE_NUMBER: "Enter phone number",
        EMAIL: "Email",
        ENTER_EMAIL: "Enter email",
        BIRTHDAY: "Birthday",
        ROLE: "Role",
        SELECT_ROLE: "Select role",
        SELECT_BIRTHDAY: "Select birthday",
        GENDER: "Gender",
        SELECT_GENDER: "Select gender",
        STAFF_PERMISSION: "Role {0}",
        SELECT_STAFF_PERMISSION: "Select role {0}",
        WORK_GROUPS: "Working {0}",
        SELECT_WORK_GROUPS: "Select working {0}",
        WORK_GROUPS_ALREADY_EXIST: "This working {0} already exists. Please choose another {1}",
        MANAGER_GROUP: "{0} management",
        GROUP_DEFAULT: "Default {0}",
        SELECT_GROUP_DEFAULT: "Select as default {0}",
        STAFF_POSITION: "{0} position",
        SELECT_STAFF_POSITION: "Select {0} position",
        PLEASE_CHOOSE_GROUP_DEFAULT: "Please select default {0}",
        SELECTED_GROUP_WILL_BE_DEFAULT_ONE: "The selected {0} will be the default {1}",
        INVITATION_STAFF: "Invite {0}",
        CREATE_INVITATION: "New invitation",
        SEND_SUCCESS: "Invitation sent successfully!",
        CONFIRM_DELETE_USER_GROUP: "Bạn có thực sự muốn xóa?",
        DELETE_USER_GROUP_SUCCESS: "Đã xóa thành công!",
        UPDATE_USER_GROUP_SUCCESS: "Cập nhật thành công!",
        CREATE_USER_GROUP_SUCCESS: "Thêm mới thành công!",
        UPDATE_STAFF_ROLE_SUCCESS: "Updated role {0} successfully!",
        NOTE_DELETE_ALL_SERVICE: "{0} will be removed from all services",
        DELETE_ALL_SERVICE: "Delete from all services",
        CONFIRM_DELETE: "Do you really want to delete this {0}?",
        CONFIRM_RESEND: "Do you really want to resend this invitation??",
        CREATE_SUCCESS: "Created a new {0} successfully!",
        UPDATE_SUCCESS: "Updated {0} information successfully!",
        DELETE_SUCCESS: "Deleted {0} successfully!",
        RESEND_SUCCESS: "The invitation was resend successfully!",
        ID_CARD_NO: "ID Card",
        ID_CARD_ISSUED_DATE: "Date of issue",
        ID_CARD_ISSUED_PLACE: "Place of issue",
        ENTER_ID_CARD_NO: "Enter ID card no",
        SELECT_ID_CARD_ISSUED_DATE: "Select issued date",
        ENTER_ID_CARD_ISSUED_PLACE: "Select issued place",
        SOCIAL_INSURANCE_CODE: "Social security code",
        ENTER_SOCIAL_INSURANCE_CODE: "Enter social security code",
        SELECT_EMPLOYMENT_DATE: "Select employment date",
        EMPLOYMENT_DATE: "Employment date",
        TERMINATIONT_DATE: "Terminationt date",
        ENTER_TERMINATIONT_DATE: "Select terminationt date",
        CHANGE_ROLE: "This {0} will lose his position as {1} management in the working {2} as well. Are you sure you want to update?",
        WRONG_SOCIAL_INSURANCE_CODE_FORMAT: "Wrong social insurance number format",
        WRONG_PASSPORT_NO_CODE_FORMAT: "Wrong passport number number format",
        NOTE_SOCIAL_INSURANCE_CODE: "(The minimum length of the social insurance number is 10 numbers)",
        WRONG_ID_CARD_NO_FORMAT: "Wrong CMND/CCCD number format",
        NOTE_ID_CARD_NO: "(The minimum length of the CMND/CCCD number is 9 numbers)",

        PASSPORT_ISSUING_COUNTRY: "Nơi cấp hộ chiếu",
        PASSPORT_EXPDATE: "Hạn hộ chiếu",
        PASSPORT_NUMBER: "Số hộ chiếu",
        SELECT_PASSPORT_ISSUING_COUNTRY: "Chọn nơi cấp hộ chiếu",
        ENTER_PASSPORT_EXPDATE: "Chọn hạn hộ chiếu",
        ENTER_PASSPORT_NUMBER: "Nhập số hộ chiếu",
        NATIONALITY: "Quốc tịch",
        SELECT_NATIONALITY: "Chọn quốc tịch",
    },

    Profile: {
        PROFILE: "Profile",
        BASIC_INFO: "Basic information",
        PERSONAL_INFORMATION: "Personal information",
        USER_CONTACT: "User contact",
        UPDATE_PASSWORD: "Update password",
        UPDATE_EMAIL: "Update email",
        SECURITY: "Security",
        CHANGE_PROFILE_SUCCESS: "Updated personal information successfully!",

        EMAIL: "Email",
        ENTER_EMAIL: "Enter email",
        NEW_EMAIL: "New email",
        ENTER_NEW_EMAIL: "Enter new email",
        GET_OTP_CODE: "Get OTP",
        COMPLETE: "Complete",
        SEND_TO: "Get code back",
        OTP_CODE: "OTP",
        ENTER_OTP_CODE: "Enter OTP",

        PASSWORD: "Password",
        OLD_PASSWORD: "Old password",
        NEW_PASSWORD: "New password",
        CONFIRM_NEW_PASSWORD: "Confirm password",
        ENTER_OLD_PASSWORD: "Enter old password",
        ENTER_NEW_PASSWORD: "Enter new password",
        ENTER_CONFIRM_NEW_PASSWORD: "Enter confirm password",
        CONFIRM_NEW_PASSWORD_VALIDATE: "Enter confirm password does not match",
        DEVICE_VERIFICATION: "Verify the device",
        CONFIRM_DEVICE_VERIFICATION_EMAIL: "Verification code will be sent to email {0}. Please enter the verification code in the box below!",
        CONFIRM_DEVICE_VERIFICATION_PASSWORD:
            "The password change verification code has been sent to your email {0}. Please enter the verification code in the box below",
        CHANGE_EMAIL_SUCCESS: "Updated email successfully!",
        CHANGE_PASSWORD_SUCCESS: "Updated password successfully!",
        CHANGE_AVTAR_SUCCESS: "Updated profile picture successfully!",

        COUNTRY: "Country",
        SELECT_COUNTRY: "Select country",
        CITY_NAME: "City",
        ENTER_CITY_NAME: "Enter city name",
        PROVINCE_STATE_NAME: "Province/state",
        ENTER_PROVINCE_STATE_NAME: "Enter province/state",
        DISTRICT_NAME: "District",
        ENTER_DISTRICT_NAME: "Enter district name",
        WARD_NAME: "Ward",
        ENTER_WARD_NAME: "Enter ward name",
        ADDRESS_LINE: "Address line",
        ENTER_ADDRESS_LINE: "Enter address line",
        ADDRESS_LINE2: "Address line 2",
        ENTER_ADDRESS_LINE2: "Enter address line 2",
        POSTAL_CODE: "Postal code",
        ENTER_POSTAL_CODE: "Enter postal code",
        LIST_USER_CONTACT: "User contact",
        UPDATE_USER_CONTACT: "Update contact",
        CREATE_USER_CONTACT: "New contact",
        UPDATE_USER_CONTACT_SUCCESS: "Updated contact information successfully!",
        CREATE_USER_CONTACT_SUCCESS: "Add new contact information successfully!",
        CONFIRM_UPDATE_CONTACT_DEFAULT: "Do you really want this contact information to be set as default?",
        UPDATE_SUCCESS: "Updated successfully!",
        CONFIRM_DELETE_CONTACT: "Do you really want delete this contact information?",
        DELETE_USER_CONTACT_SUCCESS: "The selected contact information has been successfully deleted!",
        UPDATE_ADDRESS_SUCCESS: "Update address successfully!",
        CREATE_ADDRESS_SUCCESS: "Create address successfully!",
        ADDRESS_INFO: "Address information",
    },

    TwoFactorAuth: {
        AUTHENTICATION: "Authentication",
        TITLE: "Two-Factor Authentication",
        CONTENT_1: "Two-factor authentication enhances the security of your account.",
        CONTENT_2: "Your account is not currently enable in two-factor authentication.",
        BTN_ENROLL_TFA: "Enable Two-Factor Authentication",
        CONTENT_SCAN_IMAGE: "Scan this image with your Authentication application:",
        OR_ENTER_THE_SECRET: "Or enter the secret:",
        AND_ENTER_PASSCODE: "And enter the passcode shown in the application:",
        PASS_CODE: "Passcode",
        ENTER_PASS_CODE: "Enter passcode",
        AUTHENTICATED: "Authenticated",
        UN_AUTHENTICATED: "Unauthenticated",

        VERIFY: "Verify",
        VERIFY_TFA_SUCCESS: "You have successfully signed up for two-factor authentication!",
        CONFIRM_VERIFY_TFA: "Are you sure you want to sign up for two-factor authentication?",

        BTN_DISABLE_TFA: "Disable Two-Factor Authentication",
        CONTENT_DISABLE_TFA: "You can disable two-factor authentication if needed.",
        DISABLE_TFA_SUCCESS: "You have successfully disabled two-factor authentication!",
        CONFIRM_DISABLE_TFA: "Are you sure you want to disable two-factor authentication?",

        BTN_RESET_CODE: "Reset scratch token",
        CONTENT_RESET_CODE: "If you misplaced your scratch token or have already used it to sign in you can reset it here.",
        CONFIRM_RESET_CODE: "You definitely want to reset scratch token",
        RESET_CODE_SUCCESS: "You have successfully reset scratch token!",
    },

    INVITATION: {
        EMAIL: "Email",
        FULL_NAME: "Full name",
        INVITING_TIME: "Inviting time",
        RESOURCE_NAME: "Resource name",
        CONFIRM_DELETE: "Do you want to delete this invitation?",
        DELETE_INVITATION_SUCCESS: "Delete invitation info successfully",
        INVITATION_EXPIRED: "This invitation has expired",
        CONFIRM_ACCEPT: "You definitely want to accept this invitation?",
        CONFIRM_DECLINE: "You definitely want to decline this invitation?",
        CONFIRM_RESEND: "You really want to resend this invitation?",
        RESEND_SUCCESS: "You have successfully resend the invitation",
        ACCEPT_SUCCESS: "You have successfully accepted the invitation",
        DECLINE_SUCCESS: "You have successfully declined the invitation",
        VALID_FROM: "From date",
        VALID_TO: "To date",
        CONTENT_INVITING_1: "You are invited to use {0} at {1}",
        CONTENT_INVITING_2: "You are invited to use {0}",
        CONTENT_INVITING_3: "You are invited to join organization {0}",
        WITH_ROLE: " with the role {0}",
        MESSAGE: "Message",
        ENTER_MESSAGE: "Enter message",
        NOTE_MESSAGE_INVITATION: "This notice will be included in the welcome email",
        NOTE_EMAIL_INVITATION: "Add emails individually or paste the list",

        SEND_INVITATION: "Send invite",
        ACCOUNT_SETTINGS: "Accout settings",
        ROLE: "Role",
        POLICY: "Policy",
        SELECT_POLICY: "Select policy",
        WORKFLOW: "Workflow",
        SELECT_WORKFLOW: "Select workflow",
        BUDGET: "Budget packaged",
        SELECT_BUDGET: "Select budget packaged",
        NOTE_EMAIL: "Add individual emails or paste the list",
        REQUIRED_EMAIL: "Please add email",

        COPY_INVITATION_URL: "Copy invitation url",
        RESEND_INVITATION: "Resend invitation",
    },

    CODE_NAME: {
        BASIC_INFO: "Basic information Codename",
        SEARCH_TEXT: "Search by name",
        CODE_NAME_DETAIL: "Codename detail",
        PARENT_GROUP_CODE: "000000",
        PARENT_GROUP: "Codename parent",

        CODE: "Code",
        NAME: "Name",
        SHORT_NAME: "Short name",
        ENTER_CODE: "Enter code",
        ENTER_NAME: "Enter name",
        ENTER_SHORT_NAME: "Enter short name",
        ORGANIZATION_APPLIES: "Organization applies",
        SELECT_ORGANIZATION_APPLIES: "Select organization applies",
        APPLY_SYSTEM: "Applies throughout the system",

        CODE_GROUP: "Group code",
        ENTER_CODE_GROUP: "Enter group code",
        NAME_GROUP: "Group name",
        ENTER_NAME_GROUP: "Enter group name",
        CONFIRM_DELETE: "You definitely want to delete this codename ?",
        DELETE_SUCCESS: "The codename has been successfully deleted",
        CREATE_SUCCESS: "Add new codename created successfully",
        UPDATE_SUCCESS: "Updated codename information successfully",
    },

    WORKER_NODE: {
        HOST_NAME: "Host name",
        CLEANUP_NODE: "Cleanup node",
        LAUNCH_TIME: "Launch time",
        TERMINATED_TIME: "Terminated time",
        EPOCH_TIME: "Epoch time",
        NODE_TYPE: "Node type",
        UPDATE_TIME: "Update time",
        CREATE_TIME: "Create time",
        CONFIRM_UPDATE: "You definitely want to update this worker node",
        UPDATE_SUCCESS: "Update successful",
    },

    USER: {
        ADD_NEW: "Thêm người dùng",
        NO_DATA_USER: "Hiện không có người dùng nào trong hệ thống",
    },

    RESOURCE: {
        BASIC_INFO: "Resource information",
        ADD_NEW: "Add resource",
        GROUP_NAME: "Resource name",
        GROUP_CODE: "Resource code",
        RESOURCE_URI: "Resource URI",
        INPUT_GROUP_NAME: "Input resource name",
        SELECT_GROUP_CODE: "Select resource code",
        INPUT_RESOURCE_URI: "Input resource URI (<sevice>/<module>/<feature>)",
        PUBLIC: "Public",
        PRIVATE: "Need authentication",
        PRIVATERBAC: "Need permission",
        ROLE_ACCESS: "Access role",
        SELECT_ROLE_ACCESS: "Select access role",
        ADMIN_FEATURE: "Admin feature",
        DESCRIPTION: "Description",
        INPUT_DESCRIPTION: "Input description",
        SERVICE: "Dịch vụ",
        SELECT_SERVICE: "Chọn dịch vụ",
    },

    POLICY: {
        BASIC_INFO: "Policy information",
        ADD_NEW: "Add resource",
        CODE: "Code",
        NAME: "Name",
        INPUT_NAME: "Input name",
        SERVICE: "Service",
        SELECT_SERVICE: "Select service",
        DESCRIPTION: "Description",
        INPUT_DESCRIPTION: "Input description",
        APPLICABLE_TARGETS: "Applicable targets",
        ROLE: "Role",
        GROUP: "Group User",
        USER: "User",
        ADD_NEW_TARGET: "Add new target",
        RESOURCES: "Resources",
        SEARCH_TEXT: "Search text",
        ENTER_SEARCH_TEXT: "Input search text",
    },
};

export default en;
